export const BASE_PATH = '/:lang/club'

export const RoutesPaths = {
  APP_PUBLIC: '/club/public',
  AUTH_LOGIN: `/auth/login`,
  AUTH_LOGOUT: `/auth/logout`,
  AUTH_RENEW: `/auth/renew`,
  AUTH_SURROGATE: `/auth/surrogate`,
  HOME: `${BASE_PATH}/:membership`,
  PRODUCTS: '/products',
  CONTENT_CONSUME: '/products/:productId/*',
  SALES: `/:slug/:referenceCode/*`,
  MEMBERSHIP_ADMIN_URL: process.env.MEMBERSHIP_ADMIN_URL ?? '',
  COMMUNITY: '/community',
  COMMUNITY_FEED: '/community/:communityId',
  GAMIFICATION: '/gamification',
  CREATE_COMMUNITY: `/community/create`,
  EDIT_COMMUNITY: `/community/edit`,
  IMPORT_COMMUNITY: `/community/migration`,
  CERTIFICATE_PREVIEW: '/product/:productId/certificate/:userAreaCode/preview',
  CERTIFICATE_VALIDATE: '/product/:productId/certificate/:certificateId/validate',
  ACCESS_PLUS: '/access-plus/confirmation'
} as const

export const HOTMART_URL = 'https://hotmart.com'

export const CONFIG_STATUS = 'CONFIGURED'

export const BaseNames = {
  contentConsume: (membershipSlug: string, lang: string, productId: string) =>
    `/${lang}/club/${membershipSlug}/products/${productId}`,
  community: (membershipSlug: string, lang: string) => `/${lang}/club/${membershipSlug}/community`,
  communityHomePage: (membershipSlug: string, lang: string) => `/${lang}/club/${membershipSlug}`,
  communityProductsPage: (membershipSlug: string, lang: string) =>
    `/${lang}/club/${membershipSlug}/products`,
  communityFeed: (membershipSlug: string, lang: string, productId: string) =>
    `/${lang}/club/${membershipSlug}/community/${productId}`,
  communityPostDetail: (membershipSlug: string, lang: string, productId: string, postId: string) =>
    `/${lang}/club/${membershipSlug}/community/${productId}/post/${postId}`,
  gamificatiton: (membershipSlug: string, lang: string) =>
    `/${lang}/club/${membershipSlug}/gamification`
}
